import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import CommonTable from '../../common/components/CommonTable';
import CommonLoader from '../../common/components/CommonLoader';
import TransactionsTableRow from './TransactionsTableRow';
import {
  downloadTransactionInvoice,
  downloadTransactionInvoiceCreditNote,
  refundTransaction,
} from '../TransactionsActions';

const headers = [
  {
    label: 'ID',
  },
  {
    label: 'Fee Amount',
  },
  {
    label: 'Title',
  },
  {
    label: 'Creation Date',
  },
  {
    label: 'Dealer',
  },
  {
    label: 'Organization Location',
  },
  {
    label: 'Payment status',
  },
  {
    label: 'Actions',
    className: 'transactions-table__action-header',
  },
];

function TransactionsTable({ data, offset, changeOffset, refreshData }) {
  const loaderStatus = useSelector((state) => state.transactions.get('loaderStatus'));
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [refundedTransactions, setRefundedTransactions] = useState([]);
  const dispatch = useDispatch();

  const handleRefund = () => {
    if (!selectedTransactionId) return;
    setShowAlert(false);
    setRefundedTransactions((prevState) => {
      prevState.push(selectedTransactionId);
      return prevState;
    });
    dispatch(
      refundTransaction(selectedTransactionId, () => {
        refreshData();
      }),
    );
  };

  const handleInvoiceDownload = (id) => {
    dispatch(downloadTransactionInvoice(id));
  };

  const handleCreditNoteDownload = (id) => {
    dispatch(downloadTransactionInvoiceCreditNote(id));
  };

  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            className="transaction-table"
            rowComponent={TransactionsTableRow}
            rowComponentProps={{
              setShowAlert,
              setSelectedTransactionId,
              refundedTransactions,
              handleInvoiceDownload,
              handleCreditNoteDownload,
            }}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={headers}
            title="Transactions"
            hasRowPointer={false}
          />
        </CommonLoader>
        <SweetAlert
          info
          showCancel={false}
          showConfirm={false}
          show={showAlert}
          title="Confirm Refund"
          onConfirm={handleRefund}
          onCancel={() => {
            setShowAlert(false);
          }}
        >
          {(renderProps) => (
            <div>
              <p>Are you sure you want to refund this transaction?</p>
              <div className="d-flex justify-content-center gap-2 mt-3">
                <Button
                  className="rounded-pill btn-soft-primary"
                  onClick={() => renderProps.cancel()}
                >
                  Cancel
                </Button>
                <Button
                  className="rounded-pill btn-primary"
                  onClick={() => renderProps?.confirm()}
                >
                  Confirm
                </Button>
              </div>
            </div>
          )}
        </SweetAlert>
      </Col>
    </Row>
  );
}

TransactionsTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
};

export default TransactionsTable;
